import { CookieManager } from './cookie';

export class AnalyticsManager {


  static checkCookies() {
    if (CookieManager.getCookie('cookie_consent') === 'accepted') {
      AnalyticsManager.createAnalyticsScript();
    }
  }

  static createAnalyticsScript() {
    $('body').append(`<!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-143608701-1"></script>
    <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'UA-143608701-1');
    </script>`);
  }
}
